import classNames from 'classnames';
import React, { useState } from 'react';
import ReactPlayer from 'react-player/youtube';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies
import { getThumbnail } from '@itznesbro/thumbnail-viewer';
import Icon from '../../Atoms/Icon';
import Image from '../../Atoms/Image';
import style from './VideoBox.module.css';

interface Props {
  url: string;
  className?: string;
  thumbnail?: string;
  children?:
    | string
    | string[]
    | JSX.Element
    | JSX.Element[];
}

function VideoBox({
  url,
  className,
  children,
  thumbnail
}: Props) {
  const [videoPlayState, setVideoPlayState] =
    useState(false);

  const thumbURL = getThumbnail(url);

  const handlePlayClick = (
    e:
      | React.SyntheticEvent<HTMLDivElement>
      | React.SyntheticEvent<HTMLButtonElement>
  ): void => {
    e.preventDefault();
    setVideoPlayState(true);
  };

  const wrapperClassname = classNames([
    'absolute inset-0 z-20 gap-x-7 bg-black bg-opacity-60 text-4xl text-white @md:text-6xl',
    !children && 'flex items-center justify-center'
  ]);

  return (
    <div
      className={classNames([
        className,
        'overflow-hidden rounded-xl @container'
      ])}
    >
      <div
        className={classNames([
          style['player-wrapper'],
          'relative'
        ])}
      >
        <div
          className={classNames([
            'absolute inset-0 z-10 transition-all',
            { invisible: videoPlayState }
          ])}
        >
          <Image
            src={thumbnail || thumbURL}
            className="absolute inset-0 z-10 h-full w-full object-cover"
          />
          {!children ? (
            <div className={wrapperClassname}>
              <button
                onClick={handlePlayClick}
                type="button"
                className="w-[1em] text-center text-[1.15em] transition-opacity hover:opacity-75"
              >
                <Icon icon="play-regular" />
              </button>
              <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className="w-[1em] text-center transition-opacity hover:opacity-75"
              >
                <Icon icon="external-link" />
              </a>
            </div>
          ) : (
            <div
              className={wrapperClassname}
              onClick={handlePlayClick}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handlePlayClick?.(event);
                }
              }}
            >
              {children}
            </div>
          )}
        </div>

        <ReactPlayer
          url={url}
          playsinline
          playing={videoPlayState}
          controls
          className={style['react-player']}
          width="100%"
          height="100%"
        />
      </div>
    </div>
  );
}

export default VideoBox;
